export const MCP_TECHNOLOGY_ID = 'mcp'

export const MCP_ENDPOINT_PATH = 'mcp'

export const MCP_DEFAULT_SERVER_NAME = 'graftcode-gateway'

export const MCP_CLIENT_CONFIG = `{
  "mcpServers": {
    "{serverName}": {
      "url": "{mcpUrl}"
    }
  }
}`
